import React, { Fragment, PureComponent } from 'react';
import {
  Card,
  Progress,
  Tag,
  Row,
  Col,
  Button,
  Spin,
  Drawer,
  Input,
  Tabs,
  Popover,
  Switch,
  Divider,
  Badge,
  DatePicker,
} from 'antd';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import moment from 'moment';
import router from 'umi/router';
import withRouter from 'umi/withRouter';
import styles from './index.less';
import { connect } from 'dva';
import { isEmpty } from 'lodash';
import _ from 'lodash';
import { nl2br, groupBy, decryptAES } from '../../utils/utils';

import SingleResourceTable from './SingleResourceTable';
import getCloudAccountName from '../../utils/getCloudAccountName';
import SingleResourceHeader from './components/Resource/SingleResourceHeader';
import SingleResourceMetaData from './components/Resource/SingleResourceMetaData';
import { pushParamsToUrl } from '../../utils/pushParamsToUrl';
import { getHistoricalDate } from '../../utils/getHistoricalDate';
import SingleResourcePropertiesTable from './components/SingleResourcePropertiesTable';
import Playbooks from './components/Playbooks';
import RiskTypes from './components/Resource/RiskTypes';
import { awsData, getSignatureConfigurations } from './components/Resource/RisksDummyData';
import { MapToObject } from './components/Resource/Utils/MapToObject';
import { CheckDuplicateNoOfString } from './components/Resource/Utils/CheckDuplicateString';
import { DateOfDays } from './components/Resource/Utils/DateOfDays';
import { firestore } from '@/utils/firebase';
import Exception from '@/components/Exception';
import Link from 'umi/link';
const { Meta } = Card;

const { TabPane } = Tabs;
const { Search } = Input;
@connect(
  ({
    cloudAccount,
    organisation,
    resources,
    universalDrawer,
    risks,
    suppression,
    user,
    singleRisk,
    global,
  }) => ({
    allCloudAccountsList: cloudAccount.allCloudAccountsList,
    selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
    spRisks: organisation.spRisks,
    supLoading: suppression.supLoading,
    appliedFilters: universalDrawer.appliedFilters,
    organisation: organisation.current,
    selectedDate: universalDrawer.selectedDate,
    filteredRisks: universalDrawer.filteredRisks,
    singleResourceRisks: universalDrawer.filteredRisks, // resources.current,
    drawerLoading: risks?.loadingReport,
    currentUser: user.currentUser,
    risksReport: risks.report,
    noOfRisk: universalDrawer.riskByDate,
    healthLoading: universalDrawer.healthLoading,
    cveInstanceDetails: universalDrawer.cveInstanceDetails,
    totalRisks: singleRisk.totalRisks,
    loading: singleRisk.loading,
    riskName: singleRisk.riskName,
    resource: resources,
    signatureConfigurationsData: global.globalCategories,
    currentResourceData: universalDrawer.currentResourceData,
    dataMalformed: universalDrawer.dataMalformed,
  })
)
class SingleResource extends PureComponent {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
      showSuppress: false,
      riskVisible: true,
      signatureConfigurations: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'universalDrawer/getResourceRisksByWeek',
    });

    dispatch({
      type: 'universalDrawer/getSingleResourceRisks',
    });
  }

  areArraysOfObjectsDifferent(array1, array2) {
    // Check if the arrays have different lengths
    if (array1.length !== array2.length) {
      return true;
    }

    // Check if the content of each key and value is different
    for (let i = 0; i < array1.length; i++) {
      if (!_.isEqual(array1[i], array2[i])) {
        return true;
      }
    }

    // Arrays have the same length and the content of each key and value is the same
    return false;
  }

  componentDidUpdate(prevProps) {
    const { dispatch, singleResourceRisks, risksReport, appliedFilters } = this.props;
    if (this.areArraysOfObjectsDifferent(prevProps.appliedFilters, appliedFilters)) {
      dispatch({
        type: 'universalDrawer/getSingleResourceRisks',
      });
    }
    // if (
    //   (singleResourceRisks &&
    //     prevProps.singleResourceRisks.length !== singleResourceRisks.length) ||
    //   (risksReport && prevProps.risksReport.length !== risksReport.length)
    // ) {
    //   dispatch({
    //     type: 'universalDrawer/getSingleResourceRisks',
    //   });
    // }
    // if (prevProps.spRisks !== this.props.spRisks) {
    //   dispatch({
    //     type: 'universalDrawer/getSingleResourceRisks',
    //   });
    // }
  }

  // componentWillUnmount() {
  //   const { dispatch } = this.props;
  //   dispatch({
  //     type: 'unsubResources/current',
  //   });
  //   dispatch({
  //     type: 'risks/clear',
  //   });
  //   dispatch({
  //     type: 'universalDrawer/clearWeekRisk',
  //   });
  // }

  changeTab = activeKey => {
    this.setState({
      activeTab: activeKey,
    });
  };

  openDrawer = async (params, drawerType, isCloud, riskData) => {
    const { dispatch } = this.props;
    await dispatch({
      type: 'universalDrawer/save',
      payload: {
        currentRiskData: riskData,
      },
    });
    const { appliedFilters, selectedCloudAccounts } = this.props;
    let drawerParams = params;

    let isHistoryExist = appliedFilters.find(v => v.type === 'history');

    if (isHistoryExist) {
      drawerParams.push({
        type: 'history',
        value: [isHistoryExist.value[0]],
      });
    }
    // if not receiving cloud account then add selected cloud account ids
    if (!isCloud) {
      // get selected cloud account ids
      let filterAccountsId = selectedCloudAccounts.map(val => val.id);
      // push selected cloud account params object in drawerParams
      drawerParams.push({
        type: 'cloudAccounts',
        value: filterAccountsId,
      });
    }
    pushParamsToUrl(drawerParams, drawerType);
  };

  // Date Button Trigger
  handleHistoryChange = e => {
    let { appliedFilters, dispatch } = this.props;
    dispatch({
      type: 'universalDrawer/saveSelectedDate',
      payload: {
        selectedDate: e,
      },
    });
    appliedFilters = appliedFilters.filter(v => v.type !== 'history');
    if (e) {
      let date = getHistoricalDate(e);
      let historyFilter = {
        type: 'history',
        value: [date.endTime],
      };
      appliedFilters.push(historyFilter);
    }
    this.applyFilter(appliedFilters);
  };

  applyFilter = rules => {
    let rulesStringify = JSON.stringify(rules);
    const url = window.location.search;
    let modifiedUrl = url.replace(/(filters=)[^\&]+/, `$1${rulesStringify}`);
    router.push(modifiedUrl);
  };

  // *@ This function will modified the structure of the signatures coming from global collection from firestore
  // ?Example structure ---> It will return The map of the signature configurations
  // ?That map have keys and values
  // ?EX -->   ['KEYS', 'Neglected Assets'],['KEYS', 'Lateral Movement'],

  modifiedSignatureConfigStructure = signatureConfigurations => {
    const signatureNameByKey = key => {
      switch (key) {
        case 'authentications':
          return 'Authentications';
        case 'dataAtRisk':
          return 'Data At Risk';
        case 'iamMisconfigurations':
          return 'IAM Misconfigurations';
        case 'lateralMovement':
          return 'Lateral Movement';
        case 'malware':
          return 'Malware';
        case 'neglectedAssets':
          return 'Neglected Assets';
        case 'osVulnerabilities':
          return 'OS Vulnerabilities';

        default:
          return 'Vulnerabilities';
      }
    };
    const signatures = new Map();

    Object.keys(signatureConfigurations).forEach(key => {
      signatureConfigurations[key].forEach(item => {
        signatures.set(item, signatureNameByKey(key));
      });
    });
    return signatures;
  };

  render() {
    const {
      singleResourceRisks,
      allCloudAccountsList,
      filteredRisks,
      selectedDate,
      organisation,
      signatureConfigurationsData,
      cveInstanceDetails,
      currentResourceData,
      dataMalformed,
    } = this.props;
    const currCloudAccount = allCloudAccountsList.find(
      v => v.id === currentResourceData.cloudAccountId
    );
    let projectId;
    if (currCloudAccount) {
      const userkeys = currCloudAccount?.userkeys;
      const decrypteduserkeys = JSON.parse(decryptAES(userkeys));
      projectId = decrypteduserkeys?.projectId;
    }

    const { activeTab, showSuppress } = this.state;

    // ***** Creating the vairable that will store the modified structure of the signature configurations *****
    const _signaturesConfig = this.modifiedSignatureConfigStructure(signatureConfigurationsData);

    if (dataMalformed) {
      return (
        <Exception
          style={{ marginTop: '10rem' }}
          type="500"
          title="OOPS!"
          backText="See Dashboard"
          desc="Data malformed or not found"
          linkElement={Link}
        />
      );
    }
    if (!filteredRisks || filteredRisks.length === 0) {
      return (
        <div id="single-resource" style={{ textAlign: 'center', marginTop: 250 }}>
          <Spin />
          <br />
          <p>Loading single resource...</p>
        </div>
      );
    }

    let suppressedRiskCount = 0;
    if (activeTab === '1') {
      let filterRisk = filteredRisks[0].risks.filter(val => val.status.toLowerCase() === 'fail');
      suppressedRiskCount = filterRisk.filter(v => v.suppress === true).length;
    } else {
      let filterRisk = filteredRisks[0].risks.filter(val => val.status.toLowerCase() === 'pass');
      suppressedRiskCount = filterRisk.filter(v => v.suppress === true).length;
    }

    let resourceObj = filteredRisks[0];

    let high = resourceObj.risk.filter(
      val => val.risk.toLowerCase() === 'high' && val.suppress === false
    );
    let medium = resourceObj.risks.filter(
      val => val.risk.toLowerCase() === 'medium' && val.suppress === false
    );
    let low = resourceObj.risks.filter(
      val => val.risk.toLowerCase() === 'low' && val.suppress === false
    );
    let riskLevel = 'low';
    if (high && high.length > 0) {
      riskLevel = high[0].risk;
    } else if (medium && medium.length > 0) {
      riskLevel = medium[0].risk;
    }
    let cloudAccountName;
    if (allCloudAccountsList && allCloudAccountsList.length > 0) {
      cloudAccountName = getCloudAccountName(allCloudAccountsList, filteredRisks[0].cloudAccountId);
    }

    let riskWithFailedRes = [];
    let riskWithPassedRes = [];

    if (singleResourceRisks && singleResourceRisks.length > 0) {
      singleResourceRisks.map(eachRisk => {
        // loop risks
        riskWithFailedRes =
          eachRisk.hasOwnProperty('risks') &&
          eachRisk.risks.filter(
            val => val.status.toLowerCase() === 'fail' && val.suppress === false
          );
        riskWithPassedRes =
          eachRisk.hasOwnProperty('risks') &&
          eachRisk.risks.filter(
            val => val.status.toLowerCase() === 'pass' && val.suppress === false
          );
      });
    }

    // TODO: Use Upper riskWithFailedRes and riskWithFailedRes
    let riskFailed = filteredRisks[0].risks.filter(val => val.status.toLowerCase() === 'fail');
    let riskPassed = filteredRisks[0].risks.filter(val => val.status.toLowerCase() === 'pass');
    let sigPass = riskPassed.map(riskid => riskid.signatureName);
    let sigFail = riskFailed.map(riskid => riskid.signatureName);
    let malwaresRisks = [];
    let osVulnerabilitiesRisks = [];

    // ***** Assigning the signature name to the riskFailed and riskPassed from the _signaturesConfig coming from DB *****
    sigFail = MapToObject(_signaturesConfig, sigFail);
    sigPass = MapToObject(_signaturesConfig, sigPass);

    riskFailed = riskFailed.map((risk, i) => {
      return {
        ...risk,
        type: sigFail[i] || riskFailed[i].category,
        service: filteredRisks[0]?.service,
      };
    });
    riskPassed = riskPassed.map((risk, i) => {
      return { ...risk, type: sigPass[i], service: filteredRisks[0]?.service };
    });

    // ***** Handle other types of malwares and osvuls
    if (!isEmpty(filteredRisks[0].malwares)) {
      malwaresRisks = filteredRisks[0].malwares.map(item => {
        return {
          ...item,
          service: filteredRisks[0]?.service,
          category: 'malware',
          provider: filteredRisks[0]?.provider,
        };
      });
    }
    if (!isEmpty(filteredRisks[0].osVulnerabilities)) {
      osVulnerabilitiesRisks = filteredRisks[0].osVulnerabilities.map(item => {
        return {
          ...item,
          service: filteredRisks[0]?.service,
          category: 'osVulnerabilities',
          provider: filteredRisks[0]?.provider,
        };
      });
    }

    if (sigFail && this.state.riskVisible) {
      // Add No. Of Failed Risk on DVA
      let riskData = CheckDuplicateNoOfString(sigFail);

      const { dispatch } = this.props;
      riskData = {
        ...riskData,
        'OS Vulnerabilities': filteredRisks[0].osVulnerabilities?.length,
        Malware: filteredRisks[0].malwares?.length,
      };

      dispatch({
        type: 'singleRisk/riskTypeData',
        payload: {
          riskTypes: riskData,
        },
      });

      this.setState({
        riskVisible: false,
      });
    }

    const { resource, noOfRisk, healthLoading, loading } = this.props;

    // TODO: All Data of Single Resource Data on resources

    let headerProps = {
      specificResourceName: filteredRisks[0]?.name,
      specificResourceId: filteredRisks[0]?.id,
      resourceID: resource.current[0]?.id,
      loading: loading,
      cloudAccName: cloudAccountName,
      organisation,
      region: filteredRisks[0]?.region,
      service: filteredRisks[0]?.service,
      cveInstanceDetails,
      projectId,
    };

    let resourceMetaData = {
      Status: '',
      riskLevel: riskLevel,
      region: filteredRisks[0].region,
      service: filteredRisks[0].service,
      vpc: filteredRisks[0].vpcId,
      cloudAccName: cloudAccountName,
      failed: riskWithFailedRes,
      noOfRisk: noOfRisk,
      healthLoading,
      resource: resource,
      passed: riskWithPassedRes.length,
      malwareFailed: filteredRisks[0].malwares,
      osVulnerabilitiesFailed: filteredRisks[0].osVulnerabilities,
      resourceProperties: filteredRisks[0].properties,
      provider: filteredRisks[0].provider,
    };

    let tableFailedProps = {
      openDrawer: this.openDrawer,
      resourceRisks: riskFailed,
      malwares: malwaresRisks,
      osVulnerabilities: osVulnerabilitiesRisks,
      supLoading: this.props.supLoading,
      drawerLoading: this.props.drawerLoading,
      dispatch: this.props.dispatch,
      currentUser: this.props.currentUser,
      cloudAccName: cloudAccountName,
      showSuppress,
    };
    let tablePassedProps = {
      openDrawer: this.openDrawer,
      resourceRisks: riskPassed,
      supLoading: this.props.supLoading,
      drawerLoading: this.props.drawerLoading,
      dispatch: this.props.dispatch,
      currentUser: this.props.currentUser,
      cloudAccName: cloudAccountName,
      showSuppress,
    };

    let createPlaybookProps = {
      service: filteredRisks[0].service,
      cloudAccounts: cloudAccountName,
      resource: filteredRisks[0].id,
    };
    let totalRisksCount =
      riskWithFailedRes?.length +
      filteredRisks[0].malwares?.length +
      filteredRisks[0].osVulnerabilities?.length;

    const countHandler = () => {
      let { riskName, totalRisks } = this.props;
      if (riskName?.length > 0) {
        return totalRisks;
      } else {
        return totalRisksCount ? totalRisksCount : 0;
      }
    };
    return (
      <>
        <Card bordered={false} style={{ fontSize: 14, margin: '-35px -20px' }}>
          <SingleResourceHeader {...headerProps} />
        </Card>
        <Card
          style={{ marginTop: '-2px', margin: -20, marginTop: 20 }}
          bordered={false}
          bodyStyle={{ padding: '14px 24px 27px 24px' }}
        >
          <SingleResourceMetaData {...resourceMetaData} />
        </Card>
        {/* TODO */}
        {/* {filteredRisks[0].hasOwnProperty('properties') && (
          <Card bordered={false} bodyStyle={{ padding: '9px 24px 11px 24px' }}>
            <SingleResourcePropertiesTable
              resourceProperties={filteredRisks[0].properties}
              provider={filteredRisks[0].provider}
              service={filteredRisks[0].service}
            />
          </Card>
        )} */}
        {cloudAccountName && <RiskTypes />}

        <Card
          bodyStyle={{ paddingTop: '0px' }}
          style={{ margin: '20px -39px -20px' }}
          bordered={false}
        >
          <Tabs
            activeKey={this.state.activeTab}
            onChange={this.changeTab}
            tabBarExtraContent={
              <div style={{ marginRight: '40px' }}>
                <Badge
                  showZero
                  count={suppressedRiskCount}
                  overflowCount={1000}
                  style={{
                    background: '#228FFD',
                    color: 'white',
                    fontWeight: 600,
                    marginTop: -3,
                    marginRight: 7,
                  }}
                />
                Suppressed Risks{' '}
                <Switch
                  checkedChildren="Hide"
                  unCheckedChildren="Show"
                  onChange={checked => {
                    this.setState({
                      showSuppress: checked,
                    });
                  }}
                />
                <span style={{ marginLeft: '10px' }}>
                  <DatePicker
                    style={{ width: '145px' }}
                    disabledDate={current => current && current > moment().endOf('day')}
                    placeholder="Select Date"
                    value={selectedDate ? moment(selectedDate) : moment(new Date())}
                    onChange={e => this.handleHistoryChange(e)}
                  />
                </span>
              </div>
            }
          >
            <TabPane
              tab={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ marginRight: '15px' }}>Failed</span>
                  <Badge
                    showZero
                    count={countHandler()}
                    overflowCount={1000}
                    style={{
                      background: '#F4657C',
                      color: 'white',
                      fontWeight: 600,
                      marginRight:
                        totalRisksCount > 99 ? '-7px' : totalRisksCount > 9 ? '-4px' : '',
                    }}
                  />
                </div>
              }
              key="1"
            >
              <SingleResourceTable {...tableFailedProps} />
            </TabPane>

            {riskWithPassedRes.length > 0 && (
              <TabPane
                tab={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ marginRight: '15px' }}>Passed</span>
                    <Badge
                      showZero
                      count={riskWithPassedRes.length > 0 ? riskWithPassedRes.length : 0}
                      overflowCount={1000}
                      style={{
                        background: '#3ADFA3',
                        color: 'white',
                        fontWeight: 600,
                        marginRight:
                          riskWithPassedRes.length > 99
                            ? '-7px'
                            : riskWithPassedRes.length > 9
                            ? '-4px'
                            : '',
                      }}
                    />
                  </div>
                }
                key="2"
              >
                <SingleResourceTable {...tablePassedProps} />
              </TabPane>
            )}

            <TabPane tab="Remediation" key="3">
              <Playbooks {...createPlaybookProps} />
            </TabPane>
          </Tabs>
        </Card>
      </>
    );
  }
}

export default SingleResource;
